export default __webpack_public_path__ + "static/media/vision.1b181ed1.png";